import React from "react";
import TutorsDashboardPage from "./TutorsDashboardPage";
import TutorsLibraryPage from "./TutorsLibraryPage";
import TutorsWorksheetsPage from "./TutorsWorksheetsPage";
import TutorsSettingsPage from "./TutorsSettingsPage";

export default function TutorsWorkspacePage({ section }) {
    if (section === "library") {
        return <TutorsLibraryPage />;
    }
    if (section === "worksheets") {
        return <TutorsWorksheetsPage />;
    }
    if (section === "settings") {
        return <TutorsSettingsPage />;
    }
    return <TutorsDashboardPage />;
}
